import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackStockList from '../entities/back-stock'
import appconst from '@/lib/appconst';


interface BackStockState extends ListState<BackStockList> {
    stockmodel: BackStockList,

}

class BackStockMutations extends ListMutations<BackStockList>{

}
class BackStock extends ListModule<BackStockState, any, BackStockList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackStockList>(),
        loading: false,
        stockmodel: BackStockList,
        id: 0,
        orderSite: null
    }
    actions = {
        async getAll(context: ActionContext<BackStockState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackStock/GetStockList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackStockList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },

        async deductShelfCost(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStock/DeductShelfCost?id=' + payload.data.id);
        },
        async isCheckPass(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStock/IsCheckPass?id=' + payload.data.id + '&ispass=' + payload.data.ispass);
        },
        async EditStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStock/EditStatus?id=' + payload.data.id + '&isArrived=' + payload.data.isArrived);
        },
        async processLabel(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStock/ProcessLabel?id=' + payload.data.id);
        },
        async GetHeadFee(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStock/GetHeadFee', payload.data);
            return rep.data.result;
        },
        async ShelfUpCheck(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackStock/ShelfUpCheck?id=' + payload.data.id);
            return rep.data.result;
        },
        async ShelfUp(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStock/ShelfUp', payload.data);
        },
        async CheckShelf(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/BackStock/CheckWhetherHaveShelf?id=' + payload.data.id);
            return rep.data.result;
        },
        async HandleAbnormal(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStock/HandleAbnormal',payload.data);
        },
        async impotExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetExcelExportStockList', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '入库记录.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        },
    };
    mutations = {
        setCurrentPage(state: BackStockState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackStockState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const backstocks = new BackStock();
export default backstocks;